/**
 * Price formatting and calculation utilities for sandwich ordering
 */
import { formatPrice, formatCurrency } from './currencyUtils';
import { 
  calculateSandwichPrice as dbCalculatePrice 
} from '../db';

/**
 * Format a price number as a string with the $ symbol
 * @param {number} price - The price to format
 * @returns {string} Formatted price string with $ prefix
 */
const formatPriceWithSymbol = (price) => {
  return `$${formatPrice(price)}`;
};

/**
 * Calculate the total price of a sandwich
 * @param {Object} options - The sandwich configuration options
 * @returns {number} Total price of the sandwich
 */
const calculateSandwichPrice = (options) => {
  const result = dbCalculatePrice(options);
  return result.totalPrice;
};

export {
  calculateSandwichPrice,
  formatPrice,
  formatCurrency,
  formatPriceWithSymbol
};